var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnualHires(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2ZM4.00873 11C2.90315 11 2 11.8869 2 13C2 14.6912 2.83281 15.9663 4.13499 16.7966C5.41697 17.614 7.14526 18 9 18L9.04999 17.9999C9.01721 17.8384 9 17.6712 9 17.5V13.5C9 12.2758 9.87996 11.2571 11.0419 11.0419C11.0445 11.0279 11.0472 11.0139 11.05 11L4.00873 11ZM12 11.5V12H11.5C10.6716 12 10 12.6716 10 13.5V17.5C10 18.3284 10.6716 19 11.5 19H17.5C18.3284 19 19 18.3284 19 17.5V13.5C19 12.6716 18.3284 12 17.5 12H17V11.5C17 10.6716 16.3284 10 15.5 10H13.5C12.6716 10 12 10.6716 12 11.5ZM13.5 11H15.5C15.7761 11 16 11.2239 16 11.5V12H13V11.5C13 11.2239 13.2239 11 13.5 11Z",
    fill: "#A8A9B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualHires);
export default __webpack_public_path__ + "static/media/AnnualHires.4eac15d58be937285b49fce011288d5e.svg";
export { ForwardRef as ReactComponent };